import React, { useRef } from "react";
import { CpdlcMiniMO, cpdlcMiniMOView, cpdlcTocHeldView, useCenterCursor } from "@poscon/shared-frontend";
import { useRootDispatch, useRootSelector } from "~redux/hooks";
import type { Container as PixiContainer } from "pixi.js";
import { viewPositionSelector } from "~redux/slices/eramStateSlice";
import { useDragging } from "hooks/useDragging";
import { layerZIndexMap } from "~/layerZIndexMap";
import { useEventMode } from "components/utils/InteractiveContainer";
import { cpdlcSessionSelector } from "~redux/slices/aircraftSlice";
import { processEramMessage } from "~redux/thunks/processEramMessage";
import { setAsel } from "~/redux/slices/eramTempStateSlice";
import { EramAircraftMenuProps } from "../menus/AircraftMenu";

const view = cpdlcMiniMOView;

export const CpdlcMiniMOPrompt = ({ fp }: EramAircraftMenuProps) => {
  const fpId = fp.id;
  const dispatch = useRootDispatch();
  const ref = useRef<PixiContainer | null>(null);
  const pos = useRootSelector((state) => viewPositionSelector(state, view));
  const { startDrag } = useDragging(ref, view);
  const eventMode = useEventMode();
  const session = useRootSelector((state) => cpdlcSessionSelector(state, fpId));

  useCenterCursor(ref);

  return fp && session ? (
    <CpdlcMiniMO
      ref={ref}
      pos={pos}
      startDrag={startDrag}
      zIndex={layerZIndexMap.prompts}
      eventMode={eventMode}
      session={session}
      openHeldTocMenu={() => dispatch(setAsel({ fpId, menu: cpdlcTocHeldView }))}
      fp={fp}
      dispatchCommand={(command) => dispatch(processEramMessage(command))}
      closeMenu={() => dispatch(setAsel(null))}
    />
  ) : null;
};
